// equal height
!function n(t, r, e) { function i(u, f) { if (!r[u]) { if (!t[u]) { var c = "function" == typeof require && require; if (!f && c) return c(u, !0); if (o) return o(u, !0); throw new Error("Cannot find module '" + u + "'") } var a = r[u] = { exports: {} }; t[u][0].call(a.exports, function (n) { var r = t[u][1][n]; return i(r || n) }, a, a.exports, n, t, r, e) } return r[u].exports } for (var o = "function" == typeof require && require, u = 0; u < e.length; u++)i(e[u]); return i }({ 1: [function (n, t, r) { !function (n) { function t() { var t, r = n("[data-eq]").map(function () { return n(this).data("eq") }).get(); (t = {}, r.forEach(function (n) { t[n + "::" + typeof n] = n }), Object.keys(t).map(function (n) { return t[n] })).forEach(function (t) { var r = 0; n('[data-eq="' + t + '"]').css("min-height", "").each(function () { n(this).outerHeight() > r && (r = n(this).outerHeight()) }).css("min-height", r + "px") }) } n(window).on("load", function () { t() }), n(window).resize(function () { t() }) }(jQuery) }, {}] }, {}, [1]);


 AOS.init({
     startEvent: 'load',
     duration: 700,
     offset:50,
 
 });
 window.addEventListener('load', function() {
     AOS.refresh();
 });
 
 onElementHeightChange(document.body, function(){
     AOS.refresh();
 });

 function onElementHeightChange(elm, callback) {
     var lastHeight = elm.clientHeight
     var newHeight;
 
     (function run() {
         newHeight = elm.clientHeight;      
         if (lastHeight !== newHeight) callback();
         lastHeight = newHeight;
 
         if (elm.onElementHeightChangeTimer) {
             clearTimeout(elm.onElementHeightChangeTimer); 
         }
 
         elm.onElementHeightChangeTimer = setTimeout(run, 200);
     })();
 }

//Fixed Header
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 1) {
      $("body").addClass("pgScroll_Header");
  } else {
      $("body").removeClass("pgScroll_Header");
  }
});


 if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.src;
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'js/lazysizes.min.js';
    document.body.appendChild(script);
  }

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.edition-swiper', {
  slidesPerView: 2,
  centeredSlides: true,
  centeredSlidesBounds: true,
  normalizeSlideIndex: false,
  grabCursor: true,
  loop: true,
  loopPreventsSliding: false,
  effect: 'coverflow',  
  speed: 1000,
    autoplay: {
    delay: 1000
  },
  coverflowEffect: {
    rotate: 0,
    stretch: 125,
    depth: 500,
    slideShadows: false
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },

  breakpoints: {
    0: {
  slidesPerView: 1.6,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 250,
    slideShadows: false
  }
},

    576: {
      slidesPerView: 1.8,
      coverflowEffect: {
        rotate: 0,
        stretch: 40,
        depth: 250,
        slideShadows: false
      }
    },

    768: {
      slidesPerView: 2.2,
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 350,
        slideShadows: false
      }
    },

    1024: {
      slidesPerView: 3,
      coverflowEffect: {
        rotate: 0,
        stretch: 125,
        depth: 500,
        slideShadows: false
      }
    }
  }
});

//Video Play click On Image
document.querySelectorAll('.video-box').forEach(box => {

  box.addEventListener('click', function (e) {

    const video = this.querySelector('.video');

    // 👉 If clicking different box → stop all others
    document.querySelectorAll('.video-box').forEach(otherBox => {
      const otherVideo = otherBox.querySelector('.video');

      if (otherBox !== this) {
        otherBox.classList.remove('active');
        otherVideo.pause();
        otherVideo.currentTime = 0;
      }
    });

    // 👉 Toggle play/pause for current
    if (video.paused) {
      this.classList.add('active');
      video.play();
    } else {
      video.pause();
      this.classList.remove('active');
    }

  });

});

//Best of Aukera
document.addEventListener('DOMContentLoaded',()=>{
    const slider = document.querySelector('.best-of-aukera-slider');
    const nextBtn = document.querySelector('.next-product');
    const prevBtn = document.querySelector('.prev-product');
    if (!slider || !nextBtn || !prevBtn) {
        return;
    }
    let scrollTimer;
    function getScrollAmount(){
        const card = slider.querySelector('.best-product-item');
        if(!card) return 0;
        const style = window.getComputedStyle(slider);
        const gap = parseInt(style.gap) || 0;
        const cardWidth = card.offsetWidth;
        const visible =
        Math.floor(slider.clientWidth / (cardWidth + gap));
        return (cardWidth + gap) * visible;
    }
    function updateArrows(){
        let maxScroll =
        slider.scrollWidth - slider.clientWidth;
        // left arrow
        if(slider.scrollLeft <= 5){
            prevBtn.classList.add('hide');
        }
        else{
            prevBtn.classList.remove('hide');
        }

        // right arrow
        if(slider.scrollLeft >= maxScroll - 5){
            nextBtn.classList.add('hide');
        }
        else{
            nextBtn.classList.remove('hide');
        }
    }

    nextBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:getScrollAmount(),
            behavior:'smooth'
        });

    });

    prevBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:-getScrollAmount(),
            behavior:'smooth'
        });

    });

    /*
      hide arrows during scrolling
    */

    slider.addEventListener('scroll',()=>{
        nextBtn.classList.add('hide');
        prevBtn.classList.add('hide');
        clearTimeout(scrollTimer);
        scrollTimer=setTimeout(()=>{
            updateArrows();
        },300);
    });

    window.addEventListener('resize',updateArrows);
    // initial state
    updateArrows();
});

//Bridal Slider
 document.addEventListener('DOMContentLoaded',()=>{

    const slider = document.querySelector('.bridal-slider');
    const nextBtn = document.querySelector('.next-bridal');
    const prevBtn = document.querySelector('.prev-bridal');
    if (!slider || !nextBtn || !prevBtn) {
        return;
    }
    let scrollTimer;


   function getScrollAmount() {

    const card = slider.querySelector('.bridal-product-item');

    if (!card) return 0;

    const gap = 24;

    const cardWidth = card.getBoundingClientRect().width;

    const visibleCols = Math.floor(
        slider.clientWidth / (cardWidth + gap)
    );

    return (cardWidth + gap) * visibleCols;
}



    function updateArrows(){

        let maxScroll =
        slider.scrollWidth - slider.clientWidth;


        // left arrow
        if(slider.scrollLeft <= 5){
            prevBtn.classList.add('hide');
        }
        else{
            prevBtn.classList.remove('hide');
        }



        // right arrow
        if(slider.scrollLeft >= maxScroll - 5){
            nextBtn.classList.add('hide');
        }
        else{
            nextBtn.classList.remove('hide');
        }

    }



    nextBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:getScrollAmount(),
            behavior:'smooth'
        });

    });


    prevBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:-getScrollAmount(),
            behavior:'smooth'
        });

    });



    /*
      hide arrows during scrolling
    */

    slider.addEventListener('scroll',()=>{


        nextBtn.classList.add('hide');
        prevBtn.classList.add('hide');


        clearTimeout(scrollTimer);


        scrollTimer=setTimeout(()=>{

            updateArrows();

        },300);


    });



    window.addEventListener('resize',updateArrows);


    // initial state
    updateArrows();

});

// On Hover Menu 
if (window.innerWidth > 990) {
    document.querySelectorAll('.header__inline-menu details').forEach(menu => {
        menu.addEventListener('mouseenter', () => {
            menu.setAttribute('open', '');
        });
        menu.addEventListener('mouseleave', () => {
            menu.removeAttribute('open');
        });
    });
}


// Footer Navigation On Hover
document.querySelectorAll('.footerMenu .nav-link').forEach(tab => {
    tab.addEventListener('mouseenter', function () {
        let bsTab = new bootstrap.Tab(this);
        bsTab.show();
    });
});

// Choose What we speak
document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".stories-section").forEach((section) => {

        const slider = section.querySelector(".stories-slider");
        const nextBtn = section.querySelector(".next");
        const prevBtn = section.querySelector(".prev");

        if (!slider || !nextBtn || !prevBtn) return;

        let scrollTimer;

        function getScrollAmount() {
            const card = slider.querySelector(".story-card");
            if (!card) return 0;

            const style = window.getComputedStyle(slider);
            const gap = parseInt(style.columnGap || style.gap) || 0;
            const cardWidth = card.offsetWidth;

            const visible = Math.max(
                1,
                Math.floor(slider.clientWidth / (cardWidth + gap))
            );

            return (cardWidth + gap) * visible;
        }

        function updateArrows() {
            const maxScroll = slider.scrollWidth - slider.clientWidth;

            prevBtn.classList.toggle("hide", slider.scrollLeft <= 5);
            nextBtn.classList.toggle("hide", slider.scrollLeft >= maxScroll - 5);
        }

        nextBtn.addEventListener("click", () => {
            slider.scrollBy({
                left: getScrollAmount(),
                behavior: "smooth"
            });
        });

        prevBtn.addEventListener("click", () => {
            slider.scrollBy({
                left: -getScrollAmount(),
                behavior: "smooth"
            });
        });

        slider.addEventListener("scroll", () => {

            nextBtn.classList.add("hide");
            prevBtn.classList.add("hide");

            clearTimeout(scrollTimer);

            scrollTimer = setTimeout(updateArrows, 300);

        });

        updateArrows();

        window.addEventListener("resize", updateArrows);

    });

});

//Collection Card Image Slider
document.addEventListener('DOMContentLoaded',()=>{
    const slider = document.querySelector('.proAd-slider');
    const nextBtn = document.querySelector('.next-collection-image');
    const prevBtn = document.querySelector('.prev-collection-image');
    if (!slider || !nextBtn || !prevBtn) {
        return;
    }
    let scrollTimer;
    function getScrollAmount(){
        const card = slider.querySelector('.proAd-item');
        if(!card) return 0;
        const style = window.getComputedStyle(slider);
        const gap = parseInt(style.gap) || 0;
        const cardWidth = card.offsetWidth;
        const visible =
        Math.floor(slider.clientWidth / (cardWidth + gap));
        return (cardWidth + gap) * visible;
    }
    function updateArrows(){
        let maxScroll =
        slider.scrollWidth - slider.clientWidth;
        // left arrow
        if(slider.scrollLeft <= 5){
            prevBtn.classList.add('hide');
        }
        else{
            prevBtn.classList.remove('hide');
        }

        // right arrow
        if(slider.scrollLeft >= maxScroll - 5){
            nextBtn.classList.add('hide');
        }
        else{
            nextBtn.classList.remove('hide');
        }
    }

    nextBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:getScrollAmount(),
            behavior:'smooth'
        });

    });

    prevBtn.addEventListener('click',()=>{

        slider.scrollBy({
            left:-getScrollAmount(),
            behavior:'smooth'
        });

    });

    /*
      hide arrows during scrolling
    */

    slider.addEventListener('scroll',()=>{
        nextBtn.classList.add('hide');
        prevBtn.classList.add('hide');
        clearTimeout(scrollTimer);
        scrollTimer=setTimeout(()=>{
            updateArrows();
        },300);
    });

    window.addEventListener('resize',updateArrows);
    // initial state
    updateArrows();
});

//Testimonail Slider
document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.collection-testimonial-slider');
    const nextBtn = document.querySelector('.next-testimonial-card');
    const prevBtn = document.querySelector('.prev-testimonial-card');

    if (!slider || !nextBtn || !prevBtn) return;

    let scrollTimer;
    let autoSlide;

    function getScrollAmount() {
        const card = slider.querySelector('.testimonial-Item');
        if (!card) return 0;

        const style = window.getComputedStyle(slider);
        const gap = parseInt(style.gap) || 0;
        const cardWidth = card.offsetWidth;
        const visible = Math.floor(slider.clientWidth / (cardWidth + gap));

        return (cardWidth + gap) * visible;
    }

    function updateArrows() {
        const maxScroll = slider.scrollWidth - slider.clientWidth;

        if (slider.scrollLeft <= 5) {
            prevBtn.classList.add('hide');
        } else {
            prevBtn.classList.remove('hide');
        }

        if (slider.scrollLeft >= maxScroll - 5) {
            nextBtn.classList.add('hide');
        } else {
            nextBtn.classList.remove('hide');
        }
    }

    function nextSlide() {
        const maxScroll = slider.scrollWidth - slider.clientWidth;

        if (slider.scrollLeft >= maxScroll - 5) {
            // Go back to beginning
            slider.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
        } else {
            slider.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        }
    }

    function startAutoSlide() {
        stopAutoSlide();
        autoSlide = setInterval(nextSlide, 5000); // Change every 3 seconds
    }

    function stopAutoSlide() {
        clearInterval(autoSlide);
    }

    nextBtn.addEventListener('click', () => {
        stopAutoSlide();
        nextSlide();
        startAutoSlide();
    });

    prevBtn.addEventListener('click', () => {
        stopAutoSlide();

        slider.scrollBy({
            left: -getScrollAmount(),
            behavior: 'smooth'
        });

        startAutoSlide();
    });

    slider.addEventListener('scroll', () => {
        nextBtn.classList.add('hide');
        prevBtn.classList.add('hide');

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
            updateArrows();
        }, 300);
    });

    // Pause on hover (desktop)
    slider.addEventListener('mouseenter', stopAutoSlide);
    slider.addEventListener('mouseleave', startAutoSlide);

    // Pause while touching (mobile)
    slider.addEventListener('touchstart', stopAutoSlide);
    slider.addEventListener('touchend', startAutoSlide);

    window.addEventListener('resize', updateArrows);

    updateArrows();
    startAutoSlide();

});

//Image Card Slider
document.addEventListener('DOMContentLoaded', () => {

  const sliders = document.querySelectorAll('.image-card-slider-section');

  sliders.forEach((section) => {

    const slider = section.querySelector('.image-card-slider');
    const nextBtn = section.querySelector('.next-image-card');
    const prevBtn = section.querySelector('.prev-image-card');
    if (!slider || !nextBtn || !prevBtn) {
        return;
    }
    if (!slider || !nextBtn || !prevBtn) return;

    let scrollTimer;

    function getScrollAmount() {
      const card = slider.querySelector('.imageCard-item');

      if (!card) return 0;

      const gap = parseInt(window.getComputedStyle(slider).gap) || 0;

      return card.offsetWidth + gap;
    }

    function updateArrows() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;

      prevBtn.classList.toggle('hide', slider.scrollLeft <= 5);
      nextBtn.classList.toggle('hide', slider.scrollLeft >= maxScroll - 5);
    }

    nextBtn.addEventListener('click', () => {
      slider.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        updateArrows();
      }, 100);
    });

    updateArrows();

    // Store update function for resize
    section.updateSliderArrows = updateArrows;
  });

  // Single resize listener for all sliders
  window.addEventListener('resize', () => {
    sliders.forEach((section) => {
      section.updateSliderArrows?.();
    });
  });

});

//Collection Precision Image Card
  document.addEventListener('DOMContentLoaded',()=>{
    const slider = document.querySelector('.ls-Slider-grid');
    const nextBtn = document.querySelector('.ls-slide-prev');
    const prevBtn = document.querySelector('.ls-slide-next');
    if (!slider || !nextBtn || !prevBtn) {
        return;
    }
    let scrollTimer;
    function getScrollAmount(){
        const card = slider.querySelector('.ls-imageCard-item');
        if(!card) return 0;
        const style = window.getComputedStyle(slider);
        const gap = parseInt(style.gap) || 0;
        const cardWidth = card.offsetWidth;
        const visible =
        Math.floor(slider.clientWidth / (cardWidth + gap));
        return (cardWidth + gap) * visible;
    }
    function updateArrows(){
        let maxScroll =
        slider.scrollWidth - slider.clientWidth;
        // left arrow
        if(slider.scrollLeft <= 5){
            prevBtn.classList.add('hide');
        }
        else{
            prevBtn.classList.remove('hide');
        }
 
        // right arrow
        if(slider.scrollLeft >= maxScroll - 5){
            nextBtn.classList.add('hide');
        }
        else{
            nextBtn.classList.remove('hide');
        }
    }
 
    nextBtn.addEventListener('click',()=>{
 
        slider.scrollBy({
            left:getScrollAmount(),
            behavior:'smooth'
        });
 
    });
 
    prevBtn.addEventListener('click',()=>{
 
        slider.scrollBy({
            left:-getScrollAmount(),
            behavior:'smooth'
        });
 
    });
 
    /*
      hide arrows during scrolling
    */
 
    slider.addEventListener('scroll',()=>{
        nextBtn.classList.add('hide');
        prevBtn.classList.add('hide');
        clearTimeout(scrollTimer);
        scrollTimer=setTimeout(()=>{
            updateArrows();
        },300);
    });
 
    window.addEventListener('resize',updateArrows);
    // initial state
    updateArrows();
});
 

var $slider = $('.rev-home-slider');
var slideTimer;

$slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false
});

function handleSlide() {

    clearTimeout(slideTimer);

    // Pause all videos
    $('.video-slide').each(function () {
        this.pause();
        this.currentTime = 0;
        this.onended = null;
    });

    // Current slide
    var $current = $('.rev-home-slider .slick-current');
    var video = $current.find('.video-slide').get(0);

    if (video) {

        // Video slide
        video.play().catch(() => {});

        video.onended = function () {
            $slider.slick('slickNext');
        };

    } else {

        // Image slide - change after 3 seconds
        slideTimer = setTimeout(function () {
            $slider.slick('slickNext');
        }, 3000);

    }
}

// First slide
$slider.on('init', function () {
    handleSlide();
});

// Every slide change
$slider.on('afterChange', function () {
    handleSlide();
});

// Trigger first slide
handleSlide();


//Select Option
document.querySelectorAll('.lp-select').forEach(function(select) {
    function updateSelectColor() {
        if (select.value === "") {
            select.classList.remove("selected");
        } else {
            select.classList.add("selected");
        }
    }

    updateSelectColor();
    select.addEventListener("change", updateSelectColor);
});


//Menu Slider
  document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.limitation-menu-slider-section').forEach(section => {

        const slider = section.querySelector('.limitation-menu-slider');
        const nextBtn = section.querySelector('.menu-next-item');
        const prevBtn = section.querySelector('.menu-prev-item');

        if (!slider || !nextBtn || !prevBtn) return;

        let scrollTimer;

        function getScrollAmount() {
            const card = slider.querySelector('.le-menu-item');
            if (!card) return 0;

            const style = window.getComputedStyle(slider);
            const gap = parseInt(style.gap) || 0;
            const cardWidth = card.offsetWidth;

            const visible = Math.floor(slider.clientWidth / (cardWidth + gap));

            return (cardWidth + gap) * Math.max(1, visible);
        }

        function updateArrows() {
            const maxScroll = slider.scrollWidth - slider.clientWidth;

            if (slider.scrollLeft <= 5) {
                prevBtn.classList.add('hide');
            } else {
                prevBtn.classList.remove('hide');
            }

            if (slider.scrollLeft >= maxScroll - 5) {
                nextBtn.classList.add('hide');
            } else {
                nextBtn.classList.remove('hide');
            }
        }

        nextBtn.addEventListener('click', () => {
            slider.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        });

        prevBtn.addEventListener('click', () => {
            slider.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
            });
        });

        slider.addEventListener('scroll', () => {
            nextBtn.classList.add('hide');
            prevBtn.classList.add('hide');

            clearTimeout(scrollTimer);

            scrollTimer = setTimeout(() => {
                updateArrows();
            }, 300);
        });

        window.addEventListener('resize', updateArrows);

        updateArrows();
    });

});


document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".store_ServicesSlider"),
        nextBtn = document.querySelector(".next-store_ServicesSlider"),
        prevBtn = document.querySelector(".prev-store_ServicesSlider");
    if (!slider || !nextBtn || !prevBtn) return;
    let scrollTimer;
    function getScrollAmount() {
        const card = slider.querySelector(".store_ServicesCard");
        if (!card) return 0;
        const style = window.getComputedStyle(slider),
            gap = parseInt(style.gap) || 0,
            cardWidth = card.offsetWidth,
            visible = Math.floor(slider.clientWidth / (cardWidth + gap));
        return (cardWidth + gap) * visible;
    }
    function updateArrows() {
        let maxScroll = slider.scrollWidth - slider.clientWidth;
        slider.scrollLeft <= 5 ? prevBtn.classList.add("hide") : prevBtn.classList.remove("hide"),
            slider.scrollLeft >= maxScroll - 5 ? nextBtn.classList.add("hide") : nextBtn.classList.remove("hide");
    }
    nextBtn.addEventListener("click", () => {
        slider.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
    }),
        prevBtn.addEventListener("click", () => {
            slider.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
        }),
        slider.addEventListener("scroll", () => {
            nextBtn.classList.add("hide"),
                prevBtn.classList.add("hide"),
                clearTimeout(scrollTimer),
                (scrollTimer = setTimeout(() => {
                    updateArrows();
                }, 300));
        }),
        window.addEventListener("resize", updateArrows),
        updateArrows();
});


function initMobileSlider() {
    if ($(window).width() < 768) {
        if (!$('.ver_Cardsslider').hasClass('slick-initialized')) {
            $('.ver_Cardsslider').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
            });
        }
    } else {
        if ($('.ver_Cardsslider').hasClass('slick-initialized')) {
            $('.ver_Cardsslider').slick('unslick');
        }
    }
}

initMobileSlider();

$(window).on('resize', function () {
    initMobileSlider();
});


 $(".custom-model-main").appendTo("body");

 $(window).on('load', function () {
    if ($('#autoplayInnerBannerVideo').length) {
        const video = $('#autoplayInnerBannerVideo').get(0);

        video.muted = true;
        video.currentTime = 0;

        video.play().catch(function (err) {
            console.log('Autoplay failed:', err);
        });
    }
});


// Remove class on body 08-07-25
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".mobile-menu-back-btn") 
  ) {
    document.body.classList.remove("overflow-hidden-tablet");
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.link-action[href="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const details = this.closest('details');
      if (details) {
        details.open = true;
      }
    });
  });
});


//Blog Link
 $('.table_of_content li a').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var headerHeight = $('header').outerHeight(); // Change selector if needed

        $('html, body').animate({
            scrollTop: $(target).offset().top - headerHeight
        }, 600);
    });

$('.confidence-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
    {
    breakpoint: 991,
    settings: {
        slidesToShow: 3,
    }
    },
    {
    breakpoint: 767,
    settings: {
        slidesToShow: 2,
    }
    },
    {
    breakpoint: 575,
    settings: {
        slidesToShow: 1,
    }
    }
]
    });


//
$('.explore-categories-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
});    


//Try at Home
$('.try-jewellery-experience-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
        {
            breakpoint: 767,
            settings: "unslick",
        },
        {
            breakpoint: 575,
            settings: "unslick"
        }
    ]
});

//Custom Slider
document.querySelectorAll('.scroll-outer').forEach(function (wrapper) {

    const slider = wrapper.querySelector('.scrollFor-mobile');
    const scrollbar = wrapper.querySelector('.custom-slider-scrollbar');
    const thumb = wrapper.querySelector('.custom-slider-scrollbar-thumb');

    if (!slider || !scrollbar || !thumb) return;

    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    function updateScrollbar() {

        const scrollableWidth = slider.scrollWidth - slider.clientWidth;
        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const maxLeft = trackWidth - thumbWidth;

        if (scrollableWidth <= 0 || maxLeft <= 0) {
            scrollbar.style.display = 'none';
            return;
        }

        scrollbar.style.display = 'block';

        const percentage = slider.scrollLeft / scrollableWidth;

        thumb.style.left = `${percentage * maxLeft}px`;
    }

    /* Slider scroll → move thumb */
    slider.addEventListener('scroll', updateScrollbar);

    /* Resize */
    window.addEventListener('resize', updateScrollbar);

    /* Start thumb dragging */
    thumb.addEventListener('pointerdown', function (e) {

        isDragging = true;

        startX = e.clientX;
        startLeft = parseFloat(thumb.style.left) || 0;

        thumb.setPointerCapture(e.pointerId);

        e.preventDefault();
    });

    /* Drag thumb */
    thumb.addEventListener('pointermove', function (e) {

        if (!isDragging) return;

        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const maxLeft = trackWidth - thumbWidth;

        let newLeft = startLeft + (e.clientX - startX);

        newLeft = Math.max(0, Math.min(newLeft, maxLeft));

        thumb.style.left = `${newLeft}px`;

        const percentage = maxLeft > 0
            ? newLeft / maxLeft
            : 0;

        const scrollableWidth =
            slider.scrollWidth - slider.clientWidth;

        slider.scrollLeft =
            percentage * scrollableWidth;
    });

    /* Stop dragging */
    thumb.addEventListener('pointerup', function () {
        isDragging = false;
    });

    thumb.addEventListener('pointercancel', function () {
        isDragging = false;
    });

    /* Click scrollbar track */
    scrollbar.addEventListener('pointerdown', function (e) {

        if (e.target === thumb) return;

        const rect = scrollbar.getBoundingClientRect();
        const thumbWidth = thumb.offsetWidth;

        let clickPosition =
            e.clientX - rect.left - (thumbWidth / 2);

        const maxLeft =
            scrollbar.clientWidth - thumbWidth;

        clickPosition =
            Math.max(0, Math.min(clickPosition, maxLeft));

        const percentage =
            maxLeft > 0 ? clickPosition / maxLeft : 0;

        const scrollableWidth =
            slider.scrollWidth - slider.clientWidth;

        slider.scrollLeft =
            percentage * scrollableWidth;
    });

    /* Initial state */
    updateScrollbar();

});

//My Choice My Voice
var $storiesSlider = $('.stories-of-choice-slider');


/* =========================
   SLICK
========================= */

$storiesSlider.slick({
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    infinite: false,
    autoplay: false,

    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false
            }
        }
    ]
});


/* =========================
   PLAY VIDEO WITH SOUND
========================= */

var userMuted = false;

/* =========================
   PLAY VIDEO
========================= */
function playStoryVideo(video) {
    if (!video) return;

    /* Pause all other videos */
    $storiesSlider.find('video').each(function () {
        if (this !== video) {
            this.pause();
            this.currentTime = 0;
        }
    });

    video.playsInline = true;
    video.volume = 1;
    video.muted = userMuted;          // try with sound unless user muted

    var p = video.play();
    if (p !== undefined) {
        p.catch(function () {
            /* Browser blocked sound → play muted, user can tap the sound button */
            video.muted = true;
            video.play().catch(function () {});
        });
    }
}

/* =========================
   BUTTON ICON SYNC
========================= */
function syncControls(video) {
    var $item = $(video).closest('.stories-of-choice-item');
    $item.find('.story-playpause').text(video.paused ? '▶' : '⏸');
    $item.find('.story-mute').text(video.muted ? '🔇' : '🔊');
}

$storiesSlider.find('video').on('play pause volumechange', function () {
    syncControls(this);
});

/* =========================
   PLAY / PAUSE BUTTON
========================= */
$storiesSlider.on('click', '.story-playpause', function () {
    var video = $(this).closest('.stories-of-choice-item').find('video').get(0);
    if (!video) return;

    if (video.paused) {
        video.muted = userMuted;
        video.play().catch(function () {
            video.muted = true;
            video.play().catch(function () {});
        });
    } else {
        video.pause();
    }
});

/* =========================
   MUTE / UNMUTE BUTTON
========================= */
$storiesSlider.on('click', '.story-mute', function () {
    var video = $(this).closest('.stories-of-choice-item').find('video').get(0);
    if (!video) return;

    video.muted = !video.muted;
    video.volume = 1;
    userMuted = video.muted;          // remember for next slides
});

/* =========================
   AUTO-UNMUTE ON FIRST TAP ANYWHERE (optional)
   Ignores taps on the control buttons themselves
========================= */
function autoUnmuteOnFirstTap(e) {
    if ($(e.target).closest('.story-ctrl').length) return;

    if (!userMuted) {
        var video = $storiesSlider.find('.slick-current video').get(0);
        if (video && !video.paused) {
            video.muted = false;
            video.volume = 1;
        }
    }
    $(document).off('.storiesSound');
}

$(document).on('click.storiesSound touchend.storiesSound keydown.storiesSound', autoUnmuteOnFirstTap);

/* Set the initial icons */
$storiesSlider.find('video').each(function () { syncControls(this); });


/* =========================
   DESKTOP ACTIVE VIDEO
========================= */

function playDesktopActiveVideo() {

    if (!$storiesSlider.hasClass('slick-initialized')) {
        return;
    }


    var $activeSlide = $storiesSlider.find('.slick-current');

    var video = $activeSlide.find('video').get(0);


    playStoryVideo(video);

}


/* =========================
   SLIDE CHANGE
========================= */

$storiesSlider.on('afterChange', function () {

    playDesktopActiveVideo();

});


/* =========================
   MOBILE VIDEO
========================= */

function playMobileVideo(index) {

    var $items = $storiesSlider.find('.slide-item');

    var $currentItem = $items.eq(index);

    var video = $currentItem.find('video').get(0);


    if (!video) return;


    $currentItem[0].scrollIntoView({

        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'

    });


    playStoryVideo(video);

}


/* =========================
   VIDEO END
========================= */

$storiesSlider.find('video').each(function (index) {

    $(this).on('ended', function () {

        var totalVideos =
            $storiesSlider.find('video').length;

        var currentIndex = index;


        /* =========================
           NEXT VIDEO
        ========================= */

        if (currentIndex < totalVideos - 1) {

            if ($storiesSlider.hasClass('slick-initialized')) {

                $storiesSlider.slick('slickNext');

            } else {

                playMobileVideo(currentIndex + 1);

            }

        } else {

            /* Last video */
            this.pause();

        }

    });

});


/* =========================
   INITIAL AUTOPLAY
========================= */

function initStoriesVideo() {

    if ($storiesSlider.hasClass('slick-initialized')) {

        /*
         * First video:
         * autoplay + unmuted
         */
        playDesktopActiveVideo();

    } else {

        /*
         * Mobile:
         * autoplay + unmuted
         */
        playMobileVideo(0);

    }

}


initStoriesVideo();


//Short Video Slider
$('.my-choice-my-voice-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    dots: false,
    speed: 300,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false
            }
        }
    ]
});

  $('.extra-brilliant-gallery-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
           dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        }
      }
    ]
  });


//Vault Video
document.addEventListener("DOMContentLoaded", function () {

    const videoBox = document.querySelector(".aukera-vault-video");
    if (!videoBox) return;
    const video = videoBox.querySelector(".vaultVideo");
    const playButton = videoBox.querySelector(".vault-video-play");

    if (!video || !playButton) return;

    // Hide controls initially
    video.controls = false;

    // Click custom button to play video and show controls
    playButton.addEventListener("click", function () {

        video.controls = true;

        video.play().catch(function (error) {
            console.log("Video playback failed:", error);
        });

    });

    // While playing, hide custom play button
    video.addEventListener("play", function () {
        videoBox.classList.add("is-playing");
        videoBox.classList.remove("is-paused");
        playButton.setAttribute("aria-label", "Pause video");
    });

    // When paused, show custom play button and retain controls
    video.addEventListener("pause", function () {
        videoBox.classList.remove("is-playing");
        videoBox.classList.add("is-paused");
        playButton.setAttribute("aria-label", "Play video");
    });

    // When video ends, reset controls and play button
    video.addEventListener("ended", function () {
        video.controls = false;
        videoBox.classList.remove("is-playing");
        videoBox.classList.add("is-paused");
        playButton.setAttribute("aria-label", "Play video");
    });

});